var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import { useHistory } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import * as Yup from 'yup';
import styles from './styles.module.scss';
import { Button, InputTextBox } from 'template/lib';
// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');
var ModalHelpFeedback = function (props) {
    var history = useHistory();
    var _a = useAuth(), login = _a.login, handleLogout = _a.handleLogout;
    var modalTitle = props.mustSaveFeedback ? 'Avalie o seu atendimento:' : 'Avaliação do atendimento:';
    var labelResolutionNote = props.mustSaveFeedback ? 'Classifique de 0 a 10 a resolução do seu chamado:' : 'Nota para a resolução do chamado:';
    var labelServiceNote = props.mustSaveFeedback ? 'Avalie de 0 a 10 o atendimento:' : 'Nota para o atendimento:';
    var labelFeedback = props.mustSaveFeedback ? 'Nos dê um feedback sobre o atendimento' : 'Feedback';
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    useEffect(function () {
        if (login && Date.now() > (login === null || login === void 0 ? void 0 : login.expiresIn) * 1000) {
            handleLogout();
            history.push('/');
        }
        if (!login) {
            history.push('/');
        }
    }, []);
    useEffect(function () {
        if (props.modalIsOpenHelpFeedback) {
            resetFormValues();
        }
    }, [props.modalIsOpenHelpFeedback]);
    var helpFeedbackSchema = Yup.object().shape({
        resolutionNote: Yup.number()
            .typeError('Por favor, digite um valor numérico.')
            .min(0, 'Por favor, informe uma nota entre 0 e 10.')
            .max(10, 'Por favor, informe uma nota entre 0 e 10.')
            .required('Por favor, informe uma nota.'),
        serviceNote: Yup.number()
            .typeError('Por favor, digite um valor numérico.')
            .min(0, 'Por favor, informe uma nota entre 0 e 10.')
            .max(10, 'Por favor, informe uma nota entre 0 e 10.')
            .required('Por favor, informe uma nota.'),
        feedback: Yup.string()
            .required('Por favor, informe um feedback.')
            .max(500, 'Por favor, informe no máximo 500 caracteres.')
            .min(20, 'Seu feedback deve conter no mínimo 20 caracteres.')
    });
    function resetFormValues() {
        formik.resetForm({
            values: {
                resolutionNote: '',
                serviceNote: '',
                feedback: ''
            },
        });
    }
    var formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            resolutionNote: props.resolutionNoteModalHelpFeedback,
            serviceNote: props.serviceNoteModalHelpFeedback,
            feedback: props.feedbackModalHelpFeedback
        },
        validationSchema: helpFeedbackSchema,
        onSubmit: function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    props.handleCloseModalHelpFeedback(values.resolutionNote, values.serviceNote, values.feedback);
                }
                catch (err) {
                    if (!login || Date.now() > (login === null || login === void 0 ? void 0 : login.expiresIn) * 1000) {
                        handleLogout();
                        history.push('/');
                    }
                    console.log(err);
                    alert('erro');
                }
                return [2 /*return*/];
            });
        }); },
    });
    var columns = 1;
    return (_jsx("div", { children: _jsx(Modal, __assign({ isOpen: props.modalIsOpenHelpFeedback, shouldCloseOnOverlayClick: false, onRequestClose: props.handleCloseModalHelpFeedback, overlayClassName: 'react-modal-overly', className: 'react-modal-content', contentLabel: "Example Modal", style: {
                content: {
                //height: '400px',      // altura do modal
                //margin: 'auto',       // centraliza
                },
            } }, { children: _jsxs("div", __assign({ className: '' }, { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx("h2", __assign({ className: ' font-semibold border-b-2 text-lg' }, { children: modalTitle }), void 0), props.mustSaveFeedback ?
                                _jsx(_Fragment, { children: _jsx("a", {}, void 0) }, void 0)
                                :
                                    _jsx(_Fragment, { children: _jsx(AiOutlineClose, { title: 'Fechar', className: 'cursor-pointer text-sm', onClick: props.handleCloseModalHelpFeedback }, void 0) }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.content }, { children: _jsxs("form", __assign({ onSubmit: formik.handleSubmit, className: 'mx-4 my-4' }, { children: [_jsx("div", __assign({ className: 'grid justify-items-start' }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-" + columns + " lg:grid-cols-" + columns + " my-2 justify-items-end" }, { children: [_jsx("label", __assign({ className: styles.inputLabel }, { children: labelResolutionNote }), void 0), _jsx("input", { name: 'resolutionNote', className: styles.inputText, type: 'text', value: formik.values.resolutionNote, onChange: formik.handleChange, maxLength: 2, readOnly: !props.mustSaveFeedback }, void 0), formik.errors.resolutionNote && formik.touched.resolutionNote && _jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.resolutionNote }), void 0), _jsx("label", __assign({ className: styles.inputLabel }, { children: labelServiceNote }), void 0), _jsx("input", { name: 'serviceNote', className: styles.inputText, type: 'text', value: formik.values.serviceNote, onChange: formik.handleChange, maxLength: 2, readOnly: !props.mustSaveFeedback }, void 0), formik.errors.serviceNote && formik.touched.serviceNote && _jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.serviceNote }), void 0), _jsx("div", __assign({ style: { marginTop: "-0.75rem", marginBottom: "-1rem" } }, { children: _jsx(InputTextBox, { name: 'feedback', width: '65%', height: '3/6', textareaHeight: '280px', textareaMaxHeight: '360px', label: labelFeedback, inicialValue: formik.values.feedback, onChange: formik.handleChange, disabled: !props.mustSaveFeedback, maxLength: 500, minLength: 20 }, void 0) }), void 0), formik.errors.feedback && formik.touched.feedback && _jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.feedback }), void 0)] }), void 0) }), void 0), props.mustSaveFeedback &&
                                    _jsx(_Fragment, { children: _jsx("div", __assign({ className: styles.flexButton }, { children: _jsx(Button, __assign({ type: 'submit', className: '' }, { children: "Salvar" }), void 0) }), void 0) }, void 0)] }), void 0) }), void 0)] }), void 0) }), void 0) }, void 0));
};
export default ModalHelpFeedback;
